import React, { useEffect, useRef, useState } from "react";
import {
  makeStyles,
  Switch,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Slider,
  Checkbox,
  FormControlLabel,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  InputAdornment,
  ListSubheader,
  Menu
} from "@material-ui/core";
import RecordVoiceOverOutlinedIcon from "@material-ui/icons/RecordVoiceOverOutlined";
import PlayArrowRoundedIcon from "@material-ui/icons/PlayArrowRounded";
import StopRoundedIcon from "@material-ui/icons/StopRounded";
import MicRoundedIcon from "@material-ui/icons/MicRounded";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import ScheduleOutlinedIcon from "@material-ui/icons/ScheduleOutlined";
import GraphicEqRoundedIcon from "@material-ui/icons/GraphicEqRounded";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import RefreshRoundedIcon from "@material-ui/icons/RefreshRounded";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import Visibility from "@material-ui/icons/Visibility";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import OpenInNewRoundedIcon from "@material-ui/icons/OpenInNewRounded";
import LibraryAddRoundedIcon from "@material-ui/icons/LibraryAddRounded";
import HelpOutlineRoundedIcon from "@material-ui/icons/HelpOutlineRounded";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import TimerOutlinedIcon from "@material-ui/icons/TimerOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import ChatBubbleOutlineRoundedIcon from "@material-ui/icons/ChatBubbleOutlineRounded";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const MODELOS_OPENAI = [
  { id: "gpt-4o-mini-tts", nome: "GPT-4o mini TTS", desc: "Recomendado · natural em português, segue o “jeito de falar”" },
  { id: "tts-1-hd", nome: "TTS-1 HD", desc: "Sem “jeito de falar” · em português pode soar robótico" },
  { id: "tts-1", nome: "TTS-1", desc: "Mais barato · sem “jeito de falar”, mais robótico" }
];

const MODELOS_ELEVEN = [
  { id: "eleven_multilingual_v2", nome: "Multilingual v2", desc: "Mais natural em português" },
  { id: "eleven_v3", nome: "Eleven v3", desc: "Mais expressivo" },
  { id: "eleven_turbo_v2_5", nome: "Turbo v2.5", desc: "Rápido, boa qualidade" },
  { id: "eleven_flash_v2_5", nome: "Flash v2.5", desc: "O mais rápido e barato" }
];

const TEXTO_TESTE =
  "Oi! Tudo bem? Aqui você conta com a nossa assistência na amortização: depois do primeiro " +
  "desconto, a gente te ajuda a antecipar parcelas e reduzir os juros. E a primeira parcela " +
  "fica só para fevereiro!";

const ROTEIRO_GRAVACAO =
  "Olá! Tudo bem com você? Aqui é da Consig Tech. Eu vou te ajudar a simular o seu empréstimo " +
  "consignado, de um jeito rápido e sem complicação. O valor cai direto na sua conta, e a " +
  "parcela é descontada na folha de pagamento, sem boleto. Se quiser, depois do primeiro " +
  "desconto você pode antecipar parcelas e pagar menos juros. Ficou com alguma dúvida? " +
  "Pode me perguntar, que eu te explico com calma. Combinado? Então vamos lá!";

// Rotulos da ElevenLabs em portugues
const TRADUZ = {
  female: "feminina", male: "masculina", neutral: "neutra", non_binary: "neutra",
  american: "americano", british: "britânico", australian: "australiano", irish: "irlandês",
  swedish: "sueco", transatlantic: "transatlântico", indian: "indiano", african: "africano",
  brazilian: "brasileiro", portuguese: "português", latin: "latino", spanish: "espanhol",
  young: "jovem", middle_aged: "meia-idade", "middle aged": "meia-idade", old: "madura",
  conversational: "conversa", narration: "narração", narrative_story: "narração",
  social_media: "redes sociais", informative_educational: "explicativa", characters_animation: "personagem",
  entertainment_tv: "TV", advertisement: "comercial"
};
const pt = v => TRADUZ[String(v || "").toLowerCase()] || String(v || "").replace(/_/g, " ");
const generoPt = g => {
  const x = pt(g);
  return ["feminina", "masculina", "neutra"].includes(x) ? x : x || "";
};

// "Roger - Laid-Back, Casual, Resonant" -> { nome: "Roger", estilo: "Laid-Back, Casual, Resonant" }
const partirNome = nome => {
  const t = String(nome || "");
  const i = t.indexOf(" - ");
  return i > 0 ? { nome: t.slice(0, i).trim(), estilo: t.slice(i + 3).trim() } : { nome: t, estilo: "" };
};

const GRUPO_ELEVEN = {
  cloned: "Suas vozes clonadas",
  professional: "Suas vozes clonadas",
  generated: "Suas vozes criadas",
  premade: "Vozes prontas da ElevenLabs"
};

const AMOSTRA_APOS_VALOR =
  "Pronto! Consegui liberar pra você dois mil e quinhentos reais, e o melhor: a primeira " +
  "parcela só vem em fevereiro. Assim você recebe agora e só começa a pagar lá na frente. " +
  "Ficou bom pra você?";

// Variaveis dos roteiros: no atendimento a I.A troca pelos dados reais.
const VARIAVEIS = [
  { chave: "{nome}", desc: "primeiro nome do cliente", exemplo: "Maria" },
  { chave: "{valor}", desc: "valor liberado", exemplo: "2500 reais" },
  { chave: "{parcela}", desc: "valor da parcela", exemplo: "189 reais" },
  { chave: "{prazo}", desc: "quantidade de parcelas", exemplo: "24 vezes" },
  { chave: "{primeira_parcela}", desc: "mês da 1ª parcela", exemplo: "fevereiro" },
  { chave: "{banco}", desc: "banco da oferta", exemplo: "C6" }
];
const FORMATOS = [
  { id: "audio", nome: "Só áudio", desc: "a resposta vai em voz" },
  { id: "textoAudio", nome: "Texto + áudio explicando", desc: "escreve (valores, opções, link) e manda um áudio curto logo depois" },
  { id: "texto", nome: "Só texto", desc: "explica por escrito" }
];
const formatoDe = x => x.formato || (x.emAudio === false ? "texto" : "audio");

const MODELOS_SITUACAO = [
  {
    titulo: "Depois de mandar as opções",
    quando: "Logo depois de você apresentar as opções/valores ao cliente.",
    resposta:
      "Sem repetir os números do card: acolha {nome}, diga que a primeira parcela só vem em " +
      "{primeira_parcela}, que depois do primeiro pagamento a gente ajuda na amortização, e " +
      "pergunte se ficou alguma dúvida ou se ele quer que você simule outra parcela.",
    formato: "textoAudio"
  },
  {
    titulo: "Depois do link de assinatura",
    quando: "Logo depois de mandar o link de assinatura ou de autorização.",
    resposta:
      "Explique com calma para {nome} o que vai acontecer no link: o banco pede uma selfie e a " +
      "localização (é só tocar em Permitir), leva menos de um minuto, e é para ele avisar aqui " +
      "quando terminar.",
    formato: "textoAudio"
  },
  {
    titulo: "Cliente acha a parcela alta",
    quando: "O cliente diz que a parcela ficou alta ou pesada.",
    resposta:
      "Acolha a preocupação de {nome}, lembre que a parcela é descontada direto na folha e que, " +
      "com a amortização, ele pode antecipar e pagar menos juros. Se der, ofereça simular outro prazo.",
    formato: "audio"
  },
  { titulo: "", quando: "", resposta: "", formato: "audio" }
];

const comExemplo = t =>
  VARIAVEIS.reduce((acc, v) => acc.split(v.chave).join(v.exemplo), String(t || "")).split("{name}").join("Maria");

const useStyles = makeStyles(theme => ({
  varLinha: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    flexWrap: "wrap",
    padding: "10px 12px",
    marginBottom: 16,
    borderRadius: 12,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#f8fafc",
    border: `1px dashed ${theme.palette.type === "dark" ? "rgba(255,255,255,.12)" : "#dbe3ec"}`
  },
  varChip: {
    fontFamily: "monospace",
    fontSize: "0.74rem",
    fontWeight: 700,
    padding: "2px 8px",
    borderRadius: 8,
    color: "#1E9855",
    backgroundColor: "rgba(30,152,85,.10)",
    cursor: "pointer",
    border: "none",
    "&:hover": { backgroundColor: "rgba(30,152,85,.2)" }
  },
  rotGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: 16
  },
  rotCard: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    padding: 16,
    borderRadius: 16,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.10)" : "#e5ebf2"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#ffffff",
    transition: "opacity .15s"
  },
  rotDesligado: { opacity: 0.6 },
  rotTopo: { display: "flex", alignItems: "flex-start", gap: 12 },
  rotIcone: {
    flex: "0 0 auto",
    width: 38,
    height: 38,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#1E9855",
    backgroundColor: "rgba(30,152,85,.12)"
  },
  rotTitulo: { fontSize: "0.92rem", fontWeight: 800, color: theme.palette.text.primary },
  rotSub: { fontSize: "0.74rem", color: theme.palette.text.secondary, lineHeight: 1.4, marginTop: 2 },
  rotAcoes: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginTop: "auto", paddingTop: 4 },
  rotChip: {
    fontSize: "0.64rem",
    fontWeight: 800,
    padding: "2px 9px",
    borderRadius: 20,
    whiteSpace: "nowrap"
  },
  chipVerde: { color: "#1E9855", backgroundColor: "rgba(30,152,85,.12)" },
  chipAzul: { color: "#2563eb", backgroundColor: "rgba(37,99,235,.10)" },
  chipCinza: { color: theme.palette.text.secondary, backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#eef2f6" },
  secaoSits: { marginTop: 22 },
  secaoSitsTopo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    flexWrap: "wrap",
    marginBottom: 10
  },
  sitLista: { display: "flex", flexDirection: "column", gap: 10 },
  sit: {
    borderRadius: 14,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.10)" : "#e5ebf2"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#ffffff",
    overflow: "hidden"
  },
  sitAberta: { borderColor: "rgba(30,152,85,.45)", boxShadow: "0 0 0 3px rgba(30,152,85,.08)" },
  sitCab: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 14px",
    cursor: "pointer",
    "&:hover": { backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#f8fafc" }
  },
  sitTexto: { flex: 1, minWidth: 0 },
  sitQuando: {
    fontSize: "0.74rem",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  sitSeta: { transition: "transform .2s", color: theme.palette.text.secondary },
  sitSetaAberta: { transform: "rotate(180deg)" },
  sitCorpo: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1.5fr)",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
    gap: 12,
    padding: "4px 14px 14px"
  },
  sitRodape: {
    gridColumn: "1 / -1",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    flexWrap: "wrap"
  },
  seletorLinha: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
  seletor: {
    flex: "1 1 260px",
    "& .MuiSelect-select": { display: "flex", alignItems: "center", paddingTop: 10, paddingBottom: 10 }
  },
  // Botao suave padrao da aba (Ouvir, Nova situacao, Usar...)
  ouvirBtn: {
    height: 36,
    minWidth: 0,
    padding: "0 14px",
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.82rem",
    letterSpacing: 0,
    whiteSpace: "nowrap",
    boxShadow: "none",
    color: "#1E9855",
    border: "1px solid rgba(30,152,85,.22) !important",
    backgroundColor: theme.palette.type === "dark" ? "rgba(30,152,85,.14)" : "rgba(30,152,85,.07)",
    transition: "background-color .15s, border-color .15s, transform .1s",
    "&:hover": {
      backgroundColor: "rgba(30,152,85,.16)",
      borderColor: "rgba(30,152,85,.45) !important"
    },
    "&:active": { transform: "scale(.98)" },
    "& .MuiButton-startIcon": { marginRight: 6, marginLeft: -2 },
    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.04)" : "#f1f5f9",
      borderColor: "transparent !important"
    }
  },
  // Versao maior ao lado do seletor de voz (mesma altura do campo)
  ouvirGrande: { height: 40, padding: "0 18px" },
  iconeSuave: {
    width: 40,
    height: 40,
    borderRadius: 10,
    color: "#1E9855",
    border: "1px solid rgba(30,152,85,.22)",
    backgroundColor: theme.palette.type === "dark" ? "rgba(30,152,85,.14)" : "rgba(30,152,85,.07)",
    "&:hover": { backgroundColor: "rgba(30,152,85,.16)" }
  },
  amostraLink: {
    alignSelf: "flex-start",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: 20,
    border: "none",
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: "0.74rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.05)" : "#f1f5f9",
    "&:hover": { color: "#1E9855", backgroundColor: "rgba(30,152,85,.10)" },
    "& svg": { fontSize: 16 }
  },
  botaoPerigo: {
    height: 36,
    padding: "0 12px",
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.82rem",
    color: "#dc2626",
    "&:hover": { backgroundColor: "rgba(220,38,38,.08)" }
  },
  vozLinha: { display: "flex", alignItems: "center", gap: 12, width: "100%", minWidth: 0 },
  vozAvatar: {
    flex: "0 0 auto",
    width: 34,
    height: 34,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 800,
    fontSize: "0.9rem",
    color: "#fff"
  },
  avFem: { background: "linear-gradient(135deg,#f472b6,#db2777)" },
  avMasc: { background: "linear-gradient(135deg,#60a5fa,#2563eb)" },
  avNeutra: { background: "linear-gradient(135deg,#a3a3a3,#525252)" },
  avPropria: { background: "linear-gradient(135deg,#34d399,#1E9855)" },
  vozTexto: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 2 },
  vozNomeSel: {
    fontSize: "0.9rem",
    fontWeight: 800,
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  vozEstilo: {
    fontSize: "0.72rem",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  vozTags: { display: "flex", gap: 4, flexWrap: "wrap", marginTop: 2 },
  vozTag: {
    fontSize: "0.62rem",
    fontWeight: 700,
    padding: "1px 7px",
    borderRadius: 20,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#eef2f6"
  },
  vozAviso: {
    fontSize: "0.62rem",
    fontWeight: 800,
    padding: "1px 7px",
    borderRadius: 20,
    color: "#b45309",
    backgroundColor: "rgba(245,158,11,.14)",
    whiteSpace: "nowrap"
  },
  vozItem: {
    padding: "8px 14px",
    borderRadius: 10,
    margin: "2px 6px",
    "&.Mui-selected": { backgroundColor: "rgba(30,152,85,.12)" },
    "&.Mui-selected:hover": { backgroundColor: "rgba(30,152,85,.18)" }
  },
  grupoTitulo: {
    lineHeight: "30px",
    fontSize: "0.68rem",
    fontWeight: 800,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#1E9855",
    backgroundColor: theme.palette.background.paper
  },
  playMini: {
    width: 28,
    height: 28,
    flex: "0 0 auto",
    color: "#1E9855",
    backgroundColor: "rgba(30,152,85,.10)",
    "&:hover": { backgroundColor: "rgba(30,152,85,.22)" }
  },
  bibLista: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    maxHeight: 360,
    overflowY: "auto",
    paddingRight: 2
  },
  bibItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px 10px",
    borderRadius: 12,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.10)" : "#e5ebf2"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#ffffff"
  },
  vozes: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
    gap: 8
  },
  voz: {
    position: "relative",
    textAlign: "left",
    cursor: "pointer",
    fontFamily: "inherit",
    padding: "10px 12px",
    borderRadius: 12,
    border: `1.5px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.10)" : "#e5ebf2"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#ffffff",
    transition: "border-color .15s, transform .15s",
    "&:hover": { borderColor: "rgba(30,152,85,.5)", transform: "translateY(-1px)" },
    "&:focus": { outline: "none" }
  },
  vozAtiva: {
    borderColor: "#1E9855",
    backgroundColor: theme.palette.type === "dark" ? "rgba(30,152,85,.14)" : "#f0fbf4",
    boxShadow: "0 0 0 3px rgba(30,152,85,.12)"
  },
  vozTopo: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 6 },
  vozNome: { fontSize: "0.88rem", fontWeight: 800, color: theme.palette.text.primary },
  vozDesc: { fontSize: "0.7rem", color: theme.palette.text.secondary, marginTop: 2, lineHeight: 1.3 },
  vozGenero: {
    display: "inline-block",
    marginTop: 6,
    fontSize: "0.62rem",
    fontWeight: 800,
    padding: "1px 7px",
    borderRadius: 20,
    color: "#1E9855",
    backgroundColor: "rgba(30,152,85,.12)"
  },
  play: {
    width: 30,
    height: 30,
    color: "#fff",
    background: "linear-gradient(135deg,#34d399,#1E9855)",
    "&:hover": { background: "linear-gradient(135deg,#22c55e,#15803d)" }
  },
  linhaSlider: { display: "flex", alignItems: "center", gap: 14, "& .MuiSlider-root": { color: "#1E9855" } },
  sliderRotulo: { minWidth: 120, fontSize: "0.8rem", fontWeight: 700, color: theme.palette.text.primary },
  sliderValor: { minWidth: 42, textAlign: "right", fontSize: "0.8rem", fontWeight: 800, color: "#1E9855" },
  momento: {
    display: "flex",
    alignItems: "flex-start",
    gap: 4,
    padding: "8px 10px",
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#ffffff"
  },
  momentoTitulo: { fontSize: "0.86rem", fontWeight: 700, color: theme.palette.text.primary, marginTop: 9 },
  momentoTexto: { fontSize: "0.74rem", color: theme.palette.text.secondary, lineHeight: 1.4 },
  roteiro: {
    padding: "12px 14px",
    borderRadius: 12,
    fontSize: "0.86rem",
    lineHeight: 1.6,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.type === "dark" ? "rgba(30,152,85,.10)" : "rgba(30,152,85,.06)",
    border: "1px dashed rgba(30,152,85,.35)"
  },
  gravando: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    fontWeight: 800,
    fontSize: "0.86rem",
    color: "#dc2626",
    "&::before": {
      content: '""',
      width: 10,
      height: 10,
      borderRadius: "50%",
      backgroundColor: "#dc2626",
      animation: "audioPisca 1s ease-in-out infinite"
    }
  },
  "@global": { "@keyframes audioPisca": { "0%,100%": { opacity: 1 }, "50%": { opacity: 0.25 } } },
  amostra: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "6px 10px",
    borderRadius: 10,
    border: `1px solid ${theme.palette.divider}`,
    "& audio": { height: 32, flex: 1, minWidth: 0 }
  },
  vozPropria: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    padding: "10px 12px",
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#ffffff"
  },
  dica: { fontSize: "0.74rem", color: theme.palette.text.secondary, lineHeight: 1.45 },
  guia: {
    padding: "12px 14px",
    borderRadius: 12,
    fontSize: "0.8rem",
    lineHeight: 1.55,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.type === "dark" ? "rgba(59,130,246,.10)" : "#eff6ff",
    border: "1px solid rgba(59,130,246,.25)",
    "& ol": { margin: "6px 0 0", paddingLeft: 18 },
    "& li": { marginBottom: 4 },
    "& b": { color: theme.palette.type === "dark" ? "#93c5fd" : "#1d4ed8" }
  },
  so4o: {
    display: "inline-block",
    marginTop: 6,
    marginLeft: 6,
    fontSize: "0.6rem",
    fontWeight: 800,
    padding: "1px 7px",
    borderRadius: 20,
    color: "#b45309",
    backgroundColor: "rgba(245,158,11,.15)"
  },
  filtros: {
    display: "grid",
    gridTemplateColumns: "minmax(0,2fr) minmax(0,1fr) minmax(0,1fr) auto",
    gap: 8,
    alignItems: "center",
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr 1fr" }
  },
  player: { width: "100%", marginTop: 4 }
}));

const segundos = s => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

const AbaAudio = ({ classes: c, assistantName }) => {
  const cl = useStyles();
  const [cfg, setCfg] = useState(null);
  const [vozesOpenai, setVozesOpenai] = useState([]);
  const [vozesEleven, setVozesEleven] = useState([]);
  const [sitAberta, setSitAberta] = useState(null);
  const [menuModelos, setMenuModelos] = useState(null);
  const [carregandoVozes, setCarregandoVozes] = useState(false);
  const [verGuia, setVerGuia] = useState(false);
  const [busca, setBusca] = useState({ texto: "", genero: "", idioma: "pt" });
  const [biblioteca, setBiblioteca] = useState({ vozes: [], pagina: 0, temMais: false, total: 0 });
  const [buscando, setBuscando] = useState(false);
  const [adicionando, setAdicionando] = useState("");
  const cacheAmostras = useRef({});
  const [salvando, setSalvando] = useState(false);
  const [chaveVisivel, setChaveVisivel] = useState(false);

  const [textoTeste, setTextoTeste] = useState(TEXTO_TESTE);
  const [gerando, setGerando] = useState("");
  const [audioTeste, setAudioTeste] = useState("");
  const tocador = useRef(null);

  // gravacao da voz propria
  const [amostras, setAmostras] = useState([]);
  const [gravando, setGravando] = useState(false);
  const [tempo, setTempo] = useState(0);
  const gravador = useRef(null);
  const relogio = useRef(null);
  const [nomeVoz, setNomeVoz] = useState("");
  const [autorizadoPor, setAutorizadoPor] = useState("");
  const [consentimento, setConsentimento] = useState(false);
  const [criandoVoz, setCriandoVoz] = useState(false);

  const carregar = async () => {
    try {
      const { data } = await api.get("/ai/audio");
      setCfg(data.config);
      setVozesOpenai(data.vozesOpenai || []);
      // Com chave salva, ja traz as vozes da conta para o seletor.
      if (data.config?.elevenlabs?.apiKey) {
        api
          .get("/ai/audio/elevenlabs/vozes")
          .then(r => setVozesEleven(r.data.vozes || []))
          .catch(() => {});
      }
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    carregar();
    return () => {
      if (relogio.current) clearInterval(relogio.current);
      try {
        gravador.current && gravador.current.state !== "inactive" && gravador.current.stop();
      } catch (e) {
        /* nada */
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!cfg) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <CircularProgress size={28} />
      </div>
    );
  }

  const muda = (grupo, campo, valor) =>
    setCfg(atual =>
      grupo ? { ...atual, [grupo]: { ...atual[grupo], [campo]: valor } } : { ...atual, [campo]: valor }
    );

  const salvar = async (silencioso = false, cfgNovo = null) => {
    const alvo = cfgNovo || cfg;
    if (!silencioso && alvo.ativo && alvo.provedor === "elevenlabs" && !alvo.elevenlabs.vozId) {
      toast.error("Escolha uma voz da ElevenLabs antes de salvar (no seletor \"Voz da conta\").");
      return false;
    }
    setSalvando(true);
    try {
      const { data } = await api.put("/ai/audio", alvo);
      setCfg(data.config);
      if (!silencioso) toast.success("Configurações de áudio salvas!");
      return true;
    } catch (err) {
      toastError(err);
      return false;
    } finally {
      setSalvando(false);
    }
  };

  const tocarUrl = url => {
    setAudioTeste(url);
    setTimeout(() => {
      if (!tocador.current) return;
      tocador.current.currentTime = 0;
      tocador.current.play().catch(() => {});
    }, 50);
  };

  const tocar = async (texto, sobrescrever, chave) => {
    const config = {
      ...cfg,
      ...sobrescrever,
      openai: { ...cfg.openai, ...(sobrescrever?.openai || {}) },
      elevenlabs: { ...cfg.elevenlabs, ...(sobrescrever?.elevenlabs || {}) }
    };
    // Ja ouviu esta combinacao: toca na hora, sem gerar de novo.
    const chaveCache = JSON.stringify({
      t: texto,
      p: config.provedor,
      o: config.provedor === "openai" ? config.openai : null,
      e: config.provedor === "elevenlabs" ? { ...config.elevenlabs, apiKey: "" } : null
    });
    if (cacheAmostras.current[chaveCache]) {
      tocarUrl(cacheAmostras.current[chaveCache]);
      return;
    }
    setGerando(chave);
    try {
      const { data } = await api.post(
        "/ai/audio/ouvir",
        { texto, config },
        { responseType: "blob" }
      );
      if (data.type && !data.type.startsWith("audio")) {
        const msg = JSON.parse(await data.text());
        throw new Error(msg?.error || msg?.message || "Falha ao gerar o áudio.");
      }
      const url = URL.createObjectURL(data);
      cacheAmostras.current[chaveCache] = url;
      tocarUrl(url);
    } catch (err) {
      if (err?.response?.data instanceof Blob) {
        try {
          const msg = JSON.parse(await err.response.data.text());
          toast.error(msg?.error || "Falha ao gerar o áudio.");
          return;
        } catch (e) {
          /* cai no padrao */
        }
      }
      toast.error(err?.message || "Falha ao gerar o áudio.");
    } finally {
      setGerando("");
    }
  };

  const amostraDaVoz = nome =>
    `Oi! Eu sou a ${assistantName || "assistente"}. Essa é a voz ${nome}. Posso te ajudar a simular o seu consignado?`;

  const carregarVozesEleven = async () => {
    if (!cfg.elevenlabs.apiKey) {
      toast.error("Cole a chave da ElevenLabs primeiro.");
      return;
    }
    setCarregandoVozes(true);
    try {
      if (!(await salvar(true))) return;
      const { data } = await api.get("/ai/audio/elevenlabs/vozes");
      setVozesEleven(data.vozes || []);
      if (!(data.vozes || []).length) toast.info("Nenhuma voz encontrada nessa conta.");
    } catch (err) {
      toastError(err);
    } finally {
      setCarregandoVozes(false);
    }
  };

  const tocarPreview = url => tocarUrl(url);

  const buscarBiblioteca = async (pagina = 0) => {
    if (!cfg.elevenlabs.apiKey) {
      toast.error("Cole a chave da ElevenLabs primeiro.");
      return;
    }
    setBuscando(true);
    try {
      if (pagina === 0 && !(await salvar(true))) return;
      const { data } = await api.get("/ai/audio/elevenlabs/biblioteca", {
        params: { busca: busca.texto, genero: busca.genero, idioma: busca.idioma, pagina }
      });
      setBiblioteca(b => ({
        vozes: pagina === 0 ? data.vozes : [...b.vozes, ...data.vozes],
        pagina,
        temMais: data.temMais,
        total: data.total
      }));
      if (pagina === 0 && !data.vozes.length) toast.info("Nenhuma voz encontrada com esses filtros.");
    } catch (err) {
      toastError(err);
    } finally {
      setBuscando(false);
    }
  };

  const adicionarVoz = async v => {
    setAdicionando(v.id);
    try {
      const { data } = await api.post("/ai/audio/elevenlabs/biblioteca", {
        dono: v.dono,
        vozId: v.id,
        nome: v.nome
      });
      const nova = { id: data.voz.id, nome: data.voz.nome, descricao: "da biblioteca", preview: v.preview };
      setVozesEleven(l => [nova, ...l.filter(x => x.id !== nova.id)]);
      setCfg(a => ({ ...a, elevenlabs: { ...a.elevenlabs, vozId: nova.id, vozNome: nova.nome } }));
      toast.success(`“${v.nome}” adicionada à sua conta e selecionada. Clique em Salvar.`);
    } catch (err) {
      toastError(err);
    } finally {
      setAdicionando("");
    }
  };

  // ─── gravacao ───
  const comecarGravacao = async () => {
    if (!navigator.mediaDevices?.getUserMedia || typeof window.MediaRecorder === "undefined") {
      toast.error("Este navegador não grava áudio. Use o Chrome ou envie um arquivo.");
      return;
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const rec = new MediaRecorder(stream);
      const pedacos = [];
      rec.ondataavailable = e => e.data && e.data.size && pedacos.push(e.data);
      rec.onstop = () => {
        stream.getTracks().forEach(t => t.stop());
        const blob = new Blob(pedacos, { type: rec.mimeType || "audio/webm" });
        const ext = (rec.mimeType || "audio/webm").includes("ogg") ? "ogg" : "webm";
        const arquivo = new File([blob], `gravacao-${Date.now()}.${ext}`, { type: blob.type });
        setAmostras(a => [...a, { arquivo, url: URL.createObjectURL(blob), nome: "Gravação" }]);
      };
      gravador.current = rec;
      rec.start();
      setTempo(0);
      relogio.current = setInterval(() => setTempo(t => t + 1), 1000);
      setGravando(true);
    } catch (err) {
      toast.error("Não consegui acessar o microfone. Libere a permissão no navegador.");
    }
  };

  const pararGravacao = () => {
    if (relogio.current) clearInterval(relogio.current);
    setGravando(false);
    try {
      gravador.current && gravador.current.stop();
    } catch (e) {
      /* nada */
    }
  };

  const escolherArquivos = e => {
    const lista = Array.from(e.target.files || []);
    e.target.value = "";
    const validos = lista.filter(f => f.type.startsWith("audio/") && f.size <= 25 * 1024 * 1024);
    if (validos.length < lista.length) toast.error("Só arquivos de áudio de até 25 MB.");
    setAmostras(a => [
      ...a,
      ...validos.map(f => ({ arquivo: f, url: URL.createObjectURL(f), nome: f.name }))
    ]);
  };

  const criarVoz = async () => {
    if (!cfg.elevenlabs.apiKey) {
      toast.error("A voz própria é criada na ElevenLabs: cole a chave dela no bloco de cima.");
      return;
    }
    if (!amostras.length) {
      toast.error("Grave ou envie pelo menos uma amostra.");
      return;
    }
    if (!consentimento || !autorizadoPor.trim()) {
      toast.error("Confirme a autorização da pessoa dona da voz.");
      return;
    }
    setCriandoVoz(true);
    try {
      if (!(await salvar(true))) return;
      const corpo = new FormData();
      amostras.forEach(a => corpo.append("amostras", a.arquivo));
      corpo.append("nome", nomeVoz.trim() || "Voz própria");
      corpo.append("autorizadoPor", autorizadoPor.trim());
      const { data } = await api.post("/ai/audio/vozes", corpo, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 240000
      });
      setCfg(data.config);
      setAmostras([]);
      setNomeVoz("");
      toast.success("Voz criada! Clique em “Usar esta voz” para a assistente falar com ela.");
    } catch (err) {
      toastError(err);
    } finally {
      setCriandoVoz(false);
    }
  };

  const usarVozPropria = v => {
    setCfg(atual => ({
      ...atual,
      provedor: "elevenlabs",
      elevenlabs: { ...atual.elevenlabs, vozId: v.id, vozNome: v.nome }
    }));
    toast.info(`“${v.nome}” selecionada. Clique em Salvar para valer.`);
  };

  const excluirVozPropria = async v => {
    if (!window.confirm(`Excluir a voz “${v.nome}”? Ela também é apagada da ElevenLabs.`)) return;
    try {
      const { data } = await api.delete(`/ai/audio/vozes/${encodeURIComponent(v.id)}`);
      setCfg(data.config);
      toast.success("Voz excluída.");
    } catch (err) {
      toastError(err);
    }
  };

  const ehOpenai = cfg.provedor === "openai";
  const slider = (rotulo, grupo, campo, min, max, passo, fmt = v => v.toFixed(2)) => (
    <div className={cl.linhaSlider}>
      <span className={cl.sliderRotulo}>{rotulo}</span>
      <Slider
        value={Number(cfg[grupo][campo])}
        min={min}
        max={max}
        step={passo}
        onChange={(e, v) => muda(grupo, campo, v)}
      />
      <span className={cl.sliderValor}>{fmt(Number(cfg[grupo][campo]))}</span>
    </div>
  );

  // ── Seletor de voz (OpenAI e ElevenLabs) ─────────────────────────────
  const classeAvatar = op =>
    op.propria
      ? cl.avPropria
      : op.genero === "feminina"
      ? cl.avFem
      : op.genero === "masculina"
      ? cl.avMasc
      : cl.avNeutra;

  const linhaVoz = (op, onOuvir, compacto = false) => (
    <div className={cl.vozLinha}>
      <span className={`${cl.vozAvatar} ${classeAvatar(op)}`}>
        {(op.nome || "?").trim().charAt(0).toUpperCase()}
      </span>
      <div className={cl.vozTexto}>
        <span className={cl.vozNomeSel}>{op.nome}</span>
        {op.estilo && <span className={cl.vozEstilo}>{op.estilo}</span>}
        {!compacto && op.tags && op.tags.length > 0 && (
          <span className={cl.vozTags}>
            {op.tags.map(t => (
              <span key={t} className={cl.vozTag}>
                {t}
              </span>
            ))}
          </span>
        )}
      </div>
      {op.aviso && <span className={cl.vozAviso}>{op.aviso}</span>}
      {onOuvir && (
        <Tooltip title="Ouvir em português" arrow>
          <IconButton
            size="small"
            className={cl.playMini}
            onMouseDown={e => e.stopPropagation()}
            onClick={e => {
              e.stopPropagation();
              onOuvir(op);
            }}
          >
            {gerando === op.id ? <CircularProgress size={14} /> : <PlayArrowRoundedIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
      )}
    </div>
  );

  const seletorVoz = ({ label, valor, opcoes, grupos, aoEscolher, aoOuvir, vazio, extra }) => {
    const atual = opcoes.find(o => o.id === valor);
    const itens = [];
    grupos.forEach(g => {
      const doGrupo = opcoes.filter(o => o.grupo === g);
      if (!doGrupo.length) return;
      itens.push(
        <ListSubheader key={`g-${g}`} className={cl.grupoTitulo}>
          {g}
        </ListSubheader>
      );
      doGrupo.forEach(o =>
        itens.push(
          <MenuItem key={o.id} value={o.id} className={cl.vozItem}>
            {linhaVoz(o, aoOuvir)}
          </MenuItem>
        )
      );
    });
    return (
      <div className={cl.seletorLinha}>
        <FormControl variant="outlined" size="small" className={cl.seletor}>
          <InputLabel>{label}</InputLabel>
          <Select
            label={label}
            value={atual ? valor : ""}
            displayEmpty={false}
            onChange={e => e.target.value && aoEscolher(opcoes.find(o => o.id === e.target.value))}
            renderValue={() => (atual ? linhaVoz(atual, null, true) : <span className={cl.vozEstilo}>{vazio}</span>)}
            MenuProps={{
              PaperProps: { style: { maxHeight: 460, borderRadius: 14 } },
              anchorOrigin: { vertical: "bottom", horizontal: "left" },
              transformOrigin: { vertical: "top", horizontal: "left" },
              getContentAnchorEl: null
            }}
          >
            {itens}
          </Select>
        </FormControl>
        {atual && aoOuvir && (
          <Button
            className={`${cl.ouvirBtn} ${cl.ouvirGrande}`}
            disabled={!!gerando}
            startIcon={gerando === atual.id ? <CircularProgress size={14} /> : <PlayArrowRoundedIcon />}
            onClick={() => aoOuvir(atual)}
          >
            Ouvir
          </Button>
        )}
        {extra}
      </div>
    );
  };

  const opcoesOpenai = vozesOpenai.map(v => ({
    id: v.id,
    nome: v.nome,
    estilo: v.desc,
    genero: v.genero,
    tags: [v.genero],
    grupo: v.genero === "feminina" ? "Femininas" : v.genero === "masculina" ? "Masculinas" : "Neutras",
    aviso: v.so4o && /^tts-1/.test(cfg.openai.modelo) ? "só GPT-4o mini" : "",
    so4o: !!v.so4o
  }));

  const opcoesEleven = (() => {
    const lista = vozesEleven.map(v => {
      const { nome, estilo } = partirNome(v.nome);
      const partes = String(v.descricao || "").split(" · ");
      const genero = generoPt(v.genero || partes[0]);
      const tags = [genero, pt(v.sotaque || partes[1]), pt(v.idade || partes[2]), pt(v.uso)].filter(Boolean);
      const propria = ["cloned", "professional", "generated"].includes(v.categoria);
      return {
        id: v.id,
        nome,
        estilo,
        genero,
        tags: [...new Set(tags)],
        propria,
        grupo: GRUPO_ELEVEN[v.categoria] || "Outras vozes da conta",
        nomeCompleto: v.nome,
        preview: v.preview
      };
    });
    if (cfg.elevenlabs.vozId && !lista.some(o => o.id === cfg.elevenlabs.vozId)) {
      const { nome, estilo } = partirNome(cfg.elevenlabs.vozNome || "Voz selecionada");
      lista.unshift({
        id: cfg.elevenlabs.vozId,
        nome,
        estilo,
        tags: [],
        grupo: "Em uso",
        nomeCompleto: cfg.elevenlabs.vozNome
      });
    }
    return lista;
  })();

  // ── Roteiros ──────────────────────────────────────────────────────────
  const rot = cfg.roteiros || { aposValor: {}, semResposta: {}, situacoes: [] };
  const mudaRot = (grupo, campo, valor) =>
    setCfg(atual => {
      const r = atual.roteiros || { aposValor: {}, semResposta: {}, situacoes: [] };
      return { ...atual, roteiros: { ...r, [grupo]: { ...r[grupo], [campo]: valor } } };
    });
  const mudaSit = (i, campo, valor) =>
    setCfg(atual => {
      const r = atual.roteiros;
      const lista = r.situacoes.map((x, k) => (k === i ? { ...x, [campo]: valor } : x));
      return { ...atual, roteiros: { ...r, situacoes: lista } };
    });
  const novaSit = (modelo = MODELOS_SITUACAO[MODELOS_SITUACAO.length - 1]) =>
    setCfg(atual => {
      const r = atual.roteiros;
      const nova = {
        id: `sit_${Date.now()}`,
        titulo: modelo.titulo,
        quando: modelo.quando,
        resposta: modelo.resposta,
        ativo: true,
        formato: modelo.formato,
        emAudio: modelo.formato !== "texto"
      };
      return { ...atual, roteiros: { ...r, situacoes: [...r.situacoes, nova] } };
    });
  const tirarSit = i =>
    setCfg(atual => {
      const r = atual.roteiros;
      return { ...atual, roteiros: { ...r, situacoes: r.situacoes.filter((_, k) => k !== i) } };
    });

  const momento = (campo, titulo, texto) => (
    <div className={cl.momento}>
      <Checkbox
        color="primary"
        checked={!!cfg.momentos[campo]}
        onChange={e => muda("momentos", campo, e.target.checked)}
      />
      <div>
        <div className={cl.momentoTitulo}>{titulo}</div>
        <div className={cl.momentoTexto}>{texto}</div>
      </div>
    </div>
  );

  return (
    <>
      {/* ================= VOZ DA ASSISTENTE ================= */}
      <div className={c.cfgSecao}>
        <div className={c.cfgSecaoHead}>
          <div className={c.cfgIcone}>
            <RecordVoiceOverOutlinedIcon />
          </div>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div className={c.cfgTitulo}>Voz da assistente</div>
            <div className={c.cfgSub}>
              Ela responde com mensagem de voz no WhatsApp, com a voz que você escolher.
            </div>
          </div>
          <span className={`${c.cfgPill} ${cfg.ativo ? c.cfgPillOn : c.cfgPillOff}`}>
            <span className={c.cfgPonto} /> Áudio {cfg.ativo ? "ligado" : "desligado"}
          </span>
        </div>

        <div className={c.cfgCorpo}>
          <div className={c.cfgGrid}>
            <div className={c.cfgColuna}>
              {/* Liga e motor */}
              <div className={c.cfgBloco}>
                <div className={c.cfgBlocoTitulo}>
                  <GraphicEqRoundedIcon /> Motor de voz
                </div>
                <div className={c.cfgSwitchLinha}>
                  <span>{cfg.ativo ? "Mandando áudios aos clientes" : "Áudio desligado (só texto)"}</span>
                  <Switch
                    checked={!!cfg.ativo}
                    onChange={e => muda(null, "ativo", e.target.checked)}
                    color="primary"
                  />
                </div>
                <div className={c.provedores}>
                  {[
                    { id: "openai", nome: "OpenAI", desc: "Vozes prontas · usa a chave da OpenAI já cadastrada" },
                    { id: "elevenlabs", nome: "ElevenLabs", desc: "Vozes mais naturais e voz própria (clonada)" }
                  ].map(p => {
                    const ativo = cfg.provedor === p.id;
                    return (
                      <button
                        key={p.id}
                        type="button"
                        className={`${c.familiaBtn} ${ativo ? c.familiaAtiva : c.provedorInativo}`}
                        onClick={() => muda(null, "provedor", p.id)}
                      >
                        <div className={c.familiaNome}>{p.nome}</div>
                        <div className={c.familiaDesc}>{p.desc}</div>
                        <span
                          className={`${c.provedorStatus} ${
                            ativo ? c.provedorStatusAtivo : c.provedorStatusInativo
                          }`}
                        >
                          {ativo ? "Em uso" : "Clique para usar"}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* OpenAI */}
              {ehOpenai && (
                <div className={c.cfgBloco}>
                  <div className={c.cfgBlocoTitulo}>
                    <RecordVoiceOverOutlinedIcon /> Voz (OpenAI)
                  </div>
                  <FormControl variant="outlined" size="small" fullWidth>
                    <InputLabel>Modelo</InputLabel>
                    <Select
                      label="Modelo"
                      value={cfg.openai.modelo}
                      onChange={e => muda("openai", "modelo", e.target.value)}
                    >
                      {MODELOS_OPENAI.map(m => (
                        <MenuItem key={m.id} value={m.id}>
                          <b>{m.nome}</b>&nbsp;— {m.desc}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {seletorVoz({
                    label: "Voz",
                    valor: cfg.openai.voz,
                    opcoes: opcoesOpenai,
                    grupos: ["Femininas", "Masculinas", "Neutras"],
                    vazio: "Escolha uma voz",
                    aoEscolher: op => {
                      const troca = op.so4o && /^tts-1/.test(cfg.openai.modelo);
                      const novo = {
                        ...cfg,
                        openai: { ...cfg.openai, voz: op.id, ...(troca ? { modelo: "gpt-4o-mini-tts" } : {}) }
                      };
                      setCfg(novo);
                      if (troca) toast.info(`A voz ${op.nome} só existe no GPT-4o mini TTS — modelo trocado.`);
                      salvar(true, novo).then(ok => ok && toast.success(`Voz ${op.nome} salva.`));
                    },
                    aoOuvir: op =>
                      tocar(
                        amostraDaVoz(op.nome),
                        {
                          provedor: "openai",
                          openai: {
                            voz: op.id,
                            ...(op.so4o && /^tts-1/.test(cfg.openai.modelo) ? { modelo: "gpt-4o-mini-tts" } : {})
                          }
                        },
                        op.id
                      )
                  })}
                  <TextField
                    label="Jeito de falar"
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={3}
                    value={cfg.openai.instrucoes}
                    onChange={e => muda("openai", "instrucoes", e.target.value)}
                    disabled={!/gpt-4o/.test(cfg.openai.modelo)}
                    helperText={
                      /gpt-4o/.test(cfg.openai.modelo)
                        ? "Ex.: sotaque, emoção, ritmo, se sorri ao falar."
                        : "Este modelo ignora o jeito de falar e fala seco, meio robótico. Para uma voz calma e simpática, use o GPT-4o mini TTS."
                    }
                  />
                  {slider("Velocidade", "openai", "velocidade", 0.7, 1.3, 0.05, v => `${v.toFixed(2)}x`)}
                </div>
              )}

              {/* ElevenLabs */}
              {!ehOpenai && (
                <div className={c.cfgBloco}>
                  <div className={c.cfgBlocoTitulo} style={{ justifyContent: "space-between" }}>
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <RecordVoiceOverOutlinedIcon /> Voz (ElevenLabs)
                    </span>
                    <Button size="small" startIcon={<HelpOutlineRoundedIcon />} onClick={() => setVerGuia(v => !v)}>
                      {verGuia ? "Fechar guia" : "Como configurar"}
                    </Button>
                  </div>
                  {verGuia && (
                    <div className={cl.guia}>
                      <b>Passo a passo da ElevenLabs</b>
                      <ol>
                        <li>
                          Crie a conta em <b>elevenlabs.io</b> (dá para entrar com o Google). O plano grátis
                          serve para testar; para usar no atendimento e para <b>clonar uma voz</b> é preciso
                          um plano pago (a partir do Starter).
                        </li>
                        <li>
                          No painel da ElevenLabs, abra o menu <b>Developers → API Keys</b> e clique em
                          <b> Create API Key</b>. Deixe liberadas as permissões de <b>Text to Speech</b>,
                          <b> Voices</b> e <b>Voice Library</b>. Copie a chave e cole no campo abaixo.
                        </li>
                        <li>
                          Escolha a voz de um destes jeitos:
                          <br />• <b>Biblioteca de vozes</b> (aqui embaixo): milhares de vozes reais em
                          português, gravadas e compartilhadas pelos próprios donos. Busque, ouça e clique em
                          “Adicionar e usar”.
                          <br />• <b>Vozes da conta</b>: as que já estão na sua conta da ElevenLabs.
                          <br />• <b>Minha própria voz</b> (seção de baixo): grave alguém da equipe, com a
                          autorização dessa pessoa.
                        </li>
                        <li>Ajuste os controles, teste em “Testar a voz” e clique em <b>Salvar</b>.</li>
                      </ol>
                      <div style={{ marginTop: 6 }}>
                        Clonar a voz de alguém sem autorização (famosos, clientes, outras pessoas) é proibido
                        pela ElevenLabs e pode gerar problema jurídico. Use só vozes da biblioteca ou de quem
                        autorizou.
                      </div>
                      <Button
                        size="small"
                        variant="outlined"
                        style={{ marginTop: 8 }}
                        startIcon={<OpenInNewRoundedIcon />}
                        href="https://elevenlabs.io"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Abrir a ElevenLabs
                      </Button>
                    </div>
                  )}
                  <TextField
                    label="Chave da API ElevenLabs"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={cfg.elevenlabs.apiKey}
                    onChange={e => muda("elevenlabs", "apiKey", e.target.value.trim())}
                    inputProps={{
                      autoComplete: "off",
                      "data-lpignore": "true",
                      style: { WebkitTextSecurity: chaveVisivel ? "none" : "disc" }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={() => setChaveVisivel(v => !v)}>
                            {chaveVisivel ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    helperText="ElevenLabs → Developers → API Keys (veja “Como configurar”)"
                  />
                  <FormControl variant="outlined" size="small" fullWidth>
                    <InputLabel>Modelo</InputLabel>
                    <Select
                      label="Modelo"
                      value={cfg.elevenlabs.modelo}
                      onChange={e => muda("elevenlabs", "modelo", e.target.value)}
                    >
                      {MODELOS_ELEVEN.map(m => (
                        <MenuItem key={m.id} value={m.id}>
                          <b>{m.nome}</b>&nbsp;— {m.desc}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {seletorVoz({
                    label: "Voz da conta",
                    valor: cfg.elevenlabs.vozId,
                    opcoes: opcoesEleven,
                    grupos: ["Em uso", "Suas vozes clonadas", "Suas vozes criadas", "Vozes prontas da ElevenLabs", "Outras vozes da conta"],
                    vazio: carregandoVozes ? "Carregando vozes…" : "Clique em atualizar para carregar as vozes",
                    aoEscolher: op => {
                      const novo = {
                        ...cfg,
                        elevenlabs: { ...cfg.elevenlabs, vozId: op.id, vozNome: op.nomeCompleto || op.nome }
                      };
                      setCfg(novo);
                      salvar(true, novo).then(ok => ok && toast.success(`Voz ${op.nome} salva.`));
                    },
                    aoOuvir: op =>
                      tocar(amostraDaVoz(op.nome), { provedor: "elevenlabs", elevenlabs: { vozId: op.id } }, op.id),
                    extra: (
                      <Tooltip title="Atualizar vozes da conta" arrow>
                        <span>
                          <IconButton
                            className={cl.iconeSuave}
                            onClick={carregarVozesEleven}
                            disabled={carregandoVozes}
                          >
                            {carregandoVozes ? <CircularProgress size={16} /> : <RefreshRoundedIcon fontSize="small" />}
                          </IconButton>
                        </span>
                      </Tooltip>
                    )
                  })}
                  {(() => {
                    const atual = opcoesEleven.find(o => o.id === cfg.elevenlabs.vozId);
                    return atual && atual.preview ? (
                      <button type="button" className={cl.amostraLink} onClick={() => tocarPreview(atual.preview)}>
                        <PlayArrowRoundedIcon /> Amostra original (em inglês)
                      </button>
                    ) : null;
                  })()}

                  <div className={c.cfgBlocoTitulo} style={{ marginTop: 6 }}>
                    <LibraryAddRoundedIcon /> Biblioteca de vozes
                  </div>
                  <div className={cl.filtros}>
                    <TextField
                      variant="outlined"
                      size="small"
                      placeholder="Buscar (ex.: jovem, calma, vendedora)"
                      value={busca.texto}
                      onChange={e => setBusca(b => ({ ...b, texto: e.target.value }))}
                      onKeyDown={e => e.key === "Enter" && buscarBiblioteca(0)}
                    />
                    <FormControl variant="outlined" size="small">
                      <InputLabel>Gênero</InputLabel>
                      <Select
                        label="Gênero"
                        value={busca.genero}
                        onChange={e => setBusca(b => ({ ...b, genero: e.target.value }))}
                      >
                        <MenuItem value="">Todos</MenuItem>
                        <MenuItem value="female">Feminina</MenuItem>
                        <MenuItem value="male">Masculina</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl variant="outlined" size="small">
                      <InputLabel>Idioma</InputLabel>
                      <Select
                        label="Idioma"
                        value={busca.idioma}
                        onChange={e => setBusca(b => ({ ...b, idioma: e.target.value }))}
                      >
                        <MenuItem value="pt">Português</MenuItem>
                        <MenuItem value="es">Espanhol</MenuItem>
                        <MenuItem value="en">Inglês</MenuItem>
                      </Select>
                    </FormControl>
                    <Button
                      variant="contained"
                      className={c.cfgBotao}
                      startIcon={buscando ? <CircularProgress size={14} style={{ color: "#fff" }} /> : <SearchRoundedIcon />}
                      disabled={buscando}
                      onClick={() => buscarBiblioteca(0)}
                    >
                      Buscar
                    </Button>
                  </div>
                  {biblioteca.vozes.length > 0 && (
                    <>
                      <div className={cl.dica}>
                        {biblioteca.total ? `${biblioteca.total} vozes encontradas` : ""} · ▶ toca a amostra
                        original (instantâneo).
                      </div>
                      <div className={cl.bibLista}>
                        {biblioteca.vozes.map(v => {
                          const { nome, estilo } = partirNome(v.nome);
                          const genero = generoPt(v.genero);
                          const op = {
                            id: v.id,
                            nome,
                            estilo: estilo || v.descricao || "",
                            genero,
                            tags: [...new Set([genero, pt(v.idade), pt(v.sotaque), pt(v.estilo)].filter(Boolean))]
                          };
                          return (
                            <div key={`${v.dono}-${v.id}`} className={cl.bibItem}>
                              {linhaVoz(op, v.preview ? () => tocarPreview(v.preview) : null)}
                              <Button
                                size="small"
                                className={cl.ouvirBtn}
                                style={{ minWidth: 0, whiteSpace: "nowrap" }}
                                disabled={adicionando === v.id}
                                startIcon={adicionando === v.id ? <CircularProgress size={12} /> : <LibraryAddRoundedIcon />}
                                onClick={() => adicionarVoz(v)}
                              >
                                Usar
                              </Button>
                            </div>
                          );
                        })}
                      </div>
                      {biblioteca.temMais && (
                        <Button
                          size="small"
                          variant="outlined"
                          disabled={buscando}
                          onClick={() => buscarBiblioteca(biblioteca.pagina + 1)}
                        >
                          Carregar mais
                        </Button>
                      )}
                    </>
                  )}

                  <div className={c.cfgBlocoTitulo} style={{ marginTop: 6 }}>
                    <GraphicEqRoundedIcon /> Ajustes da voz
                  </div>
                  {slider("Estabilidade", "elevenlabs", "estabilidade", 0, 1, 0.05)}
                  {slider("Semelhança", "elevenlabs", "similaridade", 0, 1, 0.05)}
                  {slider("Expressividade", "elevenlabs", "estilo", 0, 1, 0.05)}
                  {slider("Velocidade", "elevenlabs", "velocidade", 0.7, 1.2, 0.05, v => `${v.toFixed(2)}x`)}
                  <div className={cl.dica}>
                    Estabilidade baixa = mais emoção e variação; alta = mais constante. Semelhança alta
                    deixa mais parecido com a voz original.
                  </div>
                </div>
              )}
            </div>

            <div className={c.cfgColuna}>
              {/* Quando */}
              <div className={c.cfgBloco}>
                <div className={c.cfgBlocoTitulo}>
                  <ScheduleOutlinedIcon /> Quando mandar áudio
                </div>
                {momento(
                  "respostaAudio",
                  "Quando o cliente mandar áudio",
                  "Responde em áudio quem fala por áudio."
                )}
                {momento(
                  "amortizacao",
                  "Assistência na amortização",
                  "A explicação da amortização sai em voz."
                )}
                {momento("boasVindas", "Boas-vindas", "A mensagem de abertura também em voz.")}
                {momento(
                  "todas",
                  "Todas as mensagens",
                  "Toda resposta curta vira áudio (o card de opções e links continuam em texto)."
                )}
                <div className={c.cfgSwitchLinha}>
                  <span>Mandar o texto junto com o áudio</span>
                  <Switch
                    checked={!!cfg.enviarTextoJunto}
                    onChange={e => muda(null, "enviarTextoJunto", e.target.checked)}
                    color="primary"
                  />
                </div>
                <TextField
                  label="Máx. de caracteres"
                  type="number"
                  variant="outlined"
                  size="small"
                  value={cfg.maxCaracteres}
                  onChange={e => muda(null, "maxCaracteres", e.target.value)}
                  helperText="Mensagem maior que isso vai só em texto."
                />
                <div className={cl.dica}>
                  A I.A decide sozinha: conversa vai em áudio; mensagem com valor, parcela, taxa ou
                  data vai em áudio + texto (para o cliente conferir); card de opções, links, chave
                  PIX, códigos e mensagens longas vão só em texto.
                </div>
              </div>

              {/* Teste */}
              <div className={c.cfgBloco}>
                <div className={c.cfgBlocoTitulo}>
                  <PlayArrowRoundedIcon /> Testar a voz
                </div>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  minRows={4}
                  value={textoTeste}
                  onChange={e => setTextoTeste(e.target.value)}
                />
                <Button
                  variant="contained"
                  className={c.cfgBotao}
                  startIcon={gerando === "teste" ? <CircularProgress size={16} style={{ color: "#fff" }} /> : <PlayArrowRoundedIcon />}
                  disabled={!!gerando}
                  onClick={() => tocar(textoTeste, null, "teste")}
                >
                  Gerar e ouvir
                </Button>
                <audio ref={tocador} src={audioTeste || undefined} controls className={cl.player} />
                <div className={cl.dica}>
                  O teste usa o que está na tela, mesmo sem salvar.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={c.cfgRodape}>
          <span className={c.cfgRodapeTexto}>
            Áudio gerado na hora e enviado como mensagem de voz (bolinha azul).
          </span>
          <Button
            variant="contained"
            className={c.cfgBotao}
            startIcon={salvando ? <CircularProgress size={16} style={{ color: "#fff" }} /> : <SaveOutlinedIcon />}
            disabled={salvando}
            onClick={() => salvar()}
          >
            Salvar
          </Button>
        </div>
      </div>

      {/* ================= ROTEIROS ================= */}
      <div className={c.cfgSecao}>
        <div className={c.cfgSecaoHead}>
          <div className={c.cfgIcone}>
            <ForumOutlinedIcon />
          </div>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div className={c.cfgTitulo}>Roteiros da I.A</div>
            <div className={c.cfgSub}>
              Como ela explica as situações mais comuns do CLT. Vale para a voz da OpenAI e da
              ElevenLabs; com o áudio desligado, ela explica por texto.
            </div>
          </div>
          <span className={`${c.cfgPill} ${cfg.ativo ? c.cfgPillOn : c.cfgPillOff}`}>
            <span className={c.cfgPonto} /> {cfg.ativo ? "Em áudio" : "Só texto"}
          </span>
        </div>

        <div className={c.cfgCorpo}>
          <div className={cl.varLinha}>
            <span className={cl.dica} style={{ marginRight: 4 }}>
              <b>Variáveis</b> (clique para copiar) — ela troca pelos dados reais do cliente:
            </span>
            {VARIAVEIS.map(v => (
              <Tooltip key={v.chave} title={v.desc} arrow>
                <button
                  type="button"
                  className={cl.varChip}
                  onClick={() => {
                    try {
                      navigator.clipboard.writeText(v.chave);
                      toast.success(`${v.chave} copiado`);
                    } catch (e) {
                      /* sem clipboard */
                    }
                  }}
                >
                  {v.chave}
                </button>
              </Tooltip>
            ))}
          </div>

          {/* Gatilhos automaticos */}
          <div className={cl.rotGrid}>
            <div className={`${cl.rotCard} ${rot.aposValor.ativo ? "" : cl.rotDesligado}`}>
              <div className={cl.rotTopo}>
                <span className={cl.rotIcone}>
                  <MonetizationOnOutlinedIcon />
                </span>
                <div style={{ flex: 1 }}>
                  <div className={cl.rotTitulo}>Depois de mandar o valor</div>
                  <div className={cl.rotSub}>
                    Logo depois do card, um áudio curto explicando o valor liberado e o 1º pagamento.
                  </div>
                </div>
                <Switch
                  checked={!!rot.aposValor.ativo}
                  onChange={e => mudaRot("aposValor", "ativo", e.target.checked)}
                  color="primary"
                />
              </div>
              <TextField
                label="O que ela deve explicar"
                variant="outlined"
                size="small"
                fullWidth
                multiline
                minRows={3}
                maxRows={8}
                value={rot.aposValor.resposta || ""}
                onChange={e => mudaRot("aposValor", "resposta", e.target.value)}
                helperText="Ela fala com as palavras dela, usando o valor e o mês reais do cliente."
              />
              <div className={cl.rotAcoes}>
                <Button
                  size="small"
                  className={cl.ouvirBtn}
                  startIcon={gerando === "rot-valor" ? <CircularProgress size={14} /> : <PlayArrowRoundedIcon />}
                  disabled={!!gerando}
                  onClick={() => tocar(AMOSTRA_APOS_VALOR, null, "rot-valor")}
                >
                  Ouvir exemplo
                </Button>
                <span className={`${cl.rotChip} ${cl.chipAzul}`}>áudio automático</span>
              </div>
            </div>

            <div className={`${cl.rotCard} ${rot.semResposta.ativo ? "" : cl.rotDesligado}`}>
              <div className={cl.rotTopo}>
                <span className={cl.rotIcone}>
                  <TimerOutlinedIcon />
                </span>
                <div style={{ flex: 1 }}>
                  <div className={cl.rotTitulo}>Cliente sem resposta depois da oferta</div>
                  <div className={cl.rotSub}>
                    Se ele sumir logo depois dos valores, ela retoma uma vez explicando a amortização.
                    Não dispara se já saiu link, SMS ou assinatura.
                  </div>
                </div>
                <Switch
                  checked={!!rot.semResposta.ativo}
                  onChange={e => mudaRot("semResposta", "ativo", e.target.checked)}
                  color="primary"
                />
              </div>
              <TextField
                label="Esperar"
                type="number"
                variant="outlined"
                size="small"
                style={{ maxWidth: 160 }}
                value={rot.semResposta.minutos ?? 7}
                onChange={e => mudaRot("semResposta", "minutos", e.target.value)}
                InputProps={{ endAdornment: <InputAdornment position="end">min</InputAdornment> }}
              />
              <TextField
                label="O que ela deve explicar"
                variant="outlined"
                size="small"
                fullWidth
                multiline
                minRows={3}
                maxRows={8}
                value={rot.semResposta.resposta || ""}
                onChange={e => mudaRot("semResposta", "resposta", e.target.value)}
                helperText="É um roteiro rápido: ela fala do jeito dela, com o nome e os valores do cliente. Também usa quando ele recusa ou fica em dúvida."
              />
              <div className={cl.rotAcoes}>
                <Button
                  size="small"
                  className={cl.ouvirBtn}
                  startIcon={gerando === "rot-sem" ? <CircularProgress size={14} /> : <PlayArrowRoundedIcon />}
                  disabled={!!gerando || !(rot.semResposta.resposta || "").trim()}
                  onClick={() => tocar(comExemplo(rot.semResposta.resposta), null, "rot-sem")}
                >
                  Ouvir exemplo
                </Button>
                <span className={`${cl.rotChip} ${cl.chipAzul}`}>uma vez por atendimento</span>
              </div>
            </div>
          </div>

          {/* Situacoes */}
          <div className={cl.secaoSits}>
            <div className={cl.secaoSitsTopo}>
              <div>
                <div className={cl.rotTitulo}>Situações</div>
                <div className={cl.rotSub}>
                  Ela entende o sentido e explica do jeito dela, curto e acolhedor. Clique para editar.
                </div>
              </div>
              <Button
                size="small"
                className={cl.ouvirBtn}
                startIcon={<AddRoundedIcon />}
                onClick={e => setMenuModelos(e.currentTarget)}
              >
                Nova situação
              </Button>
              <Menu
                anchorEl={menuModelos}
                open={!!menuModelos}
                onClose={() => setMenuModelos(null)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{ style: { borderRadius: 14, maxWidth: 360 } }}
              >
                {MODELOS_SITUACAO.map((m, k) => (
                  <MenuItem
                    key={k}
                    className={cl.vozItem}
                    onClick={() => {
                      novaSit(m);
                      setSitAberta((rot.situacoes || []).length);
                      setMenuModelos(null);
                    }}
                  >
                    <div className={cl.vozTexto}>
                      <span className={cl.vozNomeSel}>{m.titulo || "Em branco"}</span>
                      <span className={cl.vozEstilo}>
                        {m.titulo ? FORMATOS.find(f => f.id === m.formato).nome : "Escrever do zero"}
                      </span>
                    </div>
                  </MenuItem>
                ))}
              </Menu>
            </div>

            <div className={cl.sitLista}>
              {(rot.situacoes || []).map((x, i) => {
                const aberta = sitAberta === i;
                const chave = `sit-${i}`;
                return (
                  <div key={x.id || i} className={`${cl.sit} ${aberta ? cl.sitAberta : ""}`}>
                    <div className={cl.sitCab} onClick={() => setSitAberta(aberta ? null : i)}>
                      <span className={cl.rotIcone} style={x.ativo ? undefined : { opacity: 0.5 }}>
                        <ChatBubbleOutlineRoundedIcon fontSize="small" />
                      </span>
                      <div className={cl.sitTexto}>
                        <div className={cl.rotTitulo}>{x.titulo || "Nova situação"}</div>
                        <div className={cl.sitQuando}>{x.quando || "Defina quando ela usa este roteiro"}</div>
                      </div>
                      <span className={`${cl.rotChip} ${x.ativo ? cl.chipVerde : cl.chipCinza}`}>
                        {x.ativo ? "ativo" : "desligado"}
                      </span>
                      <span
                        className={`${cl.rotChip} ${
                          cfg.ativo && formatoDe(x) !== "texto" ? cl.chipAzul : cl.chipCinza
                        }`}
                      >
                        {!cfg.ativo || formatoDe(x) === "texto"
                          ? "texto"
                          : formatoDe(x) === "textoAudio"
                          ? "texto + áudio"
                          : "áudio"}
                      </span>
                      <Tooltip title="Ouvir" arrow>
                        <span>
                          <IconButton
                            size="small"
                            className={cl.playMini}
                            disabled={!!gerando || !(x.resposta || "").trim()}
                            onClick={e => {
                              e.stopPropagation();
                              tocar(comExemplo(x.resposta), null, chave);
                            }}
                          >
                            {gerando === chave ? <CircularProgress size={14} /> : <PlayArrowRoundedIcon fontSize="small" />}
                          </IconButton>
                        </span>
                      </Tooltip>
                      <ExpandMoreRoundedIcon className={`${cl.sitSeta} ${aberta ? cl.sitSetaAberta : ""}`} />
                    </div>

                    {aberta && (
                      <div className={cl.sitCorpo}>
                        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                          <TextField
                            label="Nome"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={x.titulo}
                            onChange={e => mudaSit(i, "titulo", e.target.value)}
                          />
                          <TextField
                            label="Quando"
                            variant="outlined"
                            size="small"
                            fullWidth
                            multiline
                            minRows={3}
                            value={x.quando}
                            onChange={e => mudaSit(i, "quando", e.target.value)}
                            placeholder="Ex.: o cliente diz que vai pensar"
                          />
                        </div>
                        <TextField
                          label="O que ela deve explicar"
                          variant="outlined"
                          size="small"
                          fullWidth
                          multiline
                          minRows={6}
                          value={x.resposta}
                          onChange={e => mudaSit(i, "resposta", e.target.value)}
                        />
                        <div className={cl.sitRodape}>
                          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                            <FormControlLabel
                              control={<Switch size="small" color="primary" checked={!!x.ativo} onChange={e => mudaSit(i, "ativo", e.target.checked)} />}
                              label="Ativo"
                            />
                            <FormControl variant="outlined" size="small" style={{ minWidth: 240 }}>
                              <InputLabel>Como responder</InputLabel>
                              <Select
                                label="Como responder"
                                value={formatoDe(x)}
                                onChange={e => {
                                  mudaSit(i, "formato", e.target.value);
                                  mudaSit(i, "emAudio", e.target.value !== "texto");
                                }}
                                renderValue={v => FORMATOS.find(f => f.id === v).nome}
                              >
                                {FORMATOS.map(f => (
                                  <MenuItem key={f.id} value={f.id}>
                                    <div className={cl.vozTexto}>
                                      <span className={cl.vozNomeSel}>{f.nome}</span>
                                      <span className={cl.vozEstilo}>{f.desc}</span>
                                    </div>
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          <div style={{ display: "flex", gap: 8 }}>
                            <Button
                              size="small"
                              className={cl.ouvirBtn}
                              startIcon={gerando === chave ? <CircularProgress size={14} /> : <PlayArrowRoundedIcon />}
                              disabled={!!gerando || !(x.resposta || "").trim()}
                              onClick={() => tocar(comExemplo(x.resposta), null, chave)}
                            >
                              Ouvir
                            </Button>
                            <Button
                              size="small"
                              className={cl.botaoPerigo}
                              startIcon={<DeleteOutlineIcon />}
                              onClick={() => {
                                tirarSit(i);
                                setSitAberta(null);
                              }}
                            >
                              Remover
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className={cl.dica} style={{ marginTop: 10 }}>
              O "Ouvir" lê o texto com dados de exemplo (Maria, 2500 reais…), só para conferir a voz.
              No atendimento ela fala do jeito dela, com o nome e os valores reais. Valores, links e o
              card continuam sempre por escrito.
            </div>
          </div>
        </div>

        <div className={c.cfgRodape}>
          <span className={c.cfgRodapeTexto}>As mudanças valem a partir da próxima mensagem.</span>
          <Button
            variant="contained"
            className={c.cfgBotao}
            startIcon={salvando ? <CircularProgress size={16} style={{ color: "#fff" }} /> : <SaveOutlinedIcon />}
            disabled={salvando}
            onClick={() => salvar()}
          >
            Salvar
          </Button>
        </div>
      </div>

      {/* ================= VOZ PROPRIA ================= */}
      <div className={c.cfgSecao}>
        <div className={c.cfgSecaoHead}>
          <div className={c.cfgIcone}>
            <MicRoundedIcon />
          </div>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div className={c.cfgTitulo}>Minha própria voz</div>
            <div className={c.cfgSub}>
              Grave ou envie áudios e a assistente passa a falar com essa voz (pela ElevenLabs).
            </div>
          </div>
          <span className={`${c.cfgPill} ${cfg.vozesProprias.length ? c.cfgPillOn : c.cfgPillOff}`}>
            <span className={c.cfgPonto} /> {cfg.vozesProprias.length} voz(es)
          </span>
        </div>

        <div className={c.cfgCorpo}>
          <div className={c.cfgGrid}>
            <div className={c.cfgColuna}>
              <div className={c.cfgBloco}>
                <div className={c.cfgBlocoTitulo}>
                  <MicRoundedIcon /> 1. Grave as amostras
                </div>
                <div className={cl.dica}>
                  Leia o texto abaixo em voz natural, num lugar silencioso. Quanto mais áudio (1 a 3
                  minutos no total), mais parecida fica a voz.
                </div>
                <div className={cl.roteiro}>{ROTEIRO_GRAVACAO}</div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                  {!gravando ? (
                    <Button variant="contained" className={c.cfgBotao} startIcon={<MicRoundedIcon />} onClick={comecarGravacao}>
                      Gravar
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      style={{ background: "#dc2626", color: "#fff" }}
                      startIcon={<StopRoundedIcon />}
                      onClick={pararGravacao}
                    >
                      Parar
                    </Button>
                  )}
                  {gravando && <span className={cl.gravando}>Gravando {segundos(tempo)}</span>}
                  <Button variant="outlined" component="label" startIcon={<CloudUploadOutlinedIcon />}>
                    Enviar arquivos
                    <input hidden type="file" accept="audio/*" multiple onChange={escolherArquivos} />
                  </Button>
                </div>
                {amostras.map((a, i) => (
                  <div key={a.url} className={cl.amostra}>
                    <span style={{ fontSize: "0.8rem", fontWeight: 700 }}>#{i + 1}</span>
                    <audio src={a.url} controls />
                    <IconButton
                      size="small"
                      onClick={() => {
                        URL.revokeObjectURL(a.url);
                        setAmostras(l => l.filter(x => x !== a));
                      }}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </div>
                ))}
              </div>
            </div>

            <div className={c.cfgColuna}>
              <div className={c.cfgBloco}>
                <div className={c.cfgBlocoTitulo}>
                  <CheckCircleRoundedIcon /> 2. Crie a voz
                </div>
                <TextField
                  label="Nome da voz"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={nomeVoz}
                  onChange={e => setNomeVoz(e.target.value)}
                  placeholder="Ex.: Catarina"
                />
                <TextField
                  label="Quem autorizou"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={autorizadoPor}
                  onChange={e => setAutorizadoPor(e.target.value)}
                  placeholder="Nome completo da pessoa dona da voz"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={consentimento}
                      onChange={e => setConsentimento(e.target.checked)}
                    />
                  }
                  label={
                    <span className={cl.dica}>
                      Confirmo que a pessoa dona desta voz autorizou, por escrito, o uso dela pela
                      assistente virtual da empresa.
                    </span>
                  }
                />
                <Button
                  variant="contained"
                  className={c.cfgBotao}
                  startIcon={criandoVoz ? <CircularProgress size={16} style={{ color: "#fff" }} /> : <RecordVoiceOverOutlinedIcon />}
                  disabled={criandoVoz || !amostras.length}
                  onClick={criarVoz}
                >
                  Criar minha voz
                </Button>
                <div className={cl.dica}>
                  Precisa da chave da ElevenLabs (bloco “Voz” acima, motor ElevenLabs) e de um plano
                  que permita clonar voz.
                </div>
              </div>

              <div className={c.cfgBloco}>
                <div className={c.cfgBlocoTitulo}>
                  <RecordVoiceOverOutlinedIcon /> Vozes criadas
                </div>
                {!cfg.vozesProprias.length && (
                  <div className={cl.dica}>Nenhuma voz própria ainda.</div>
                )}
                {cfg.vozesProprias.map(v => {
                  const emUso = cfg.provedor === "elevenlabs" && cfg.elevenlabs.vozId === v.id;
                  return (
                    <div key={v.id} className={cl.vozPropria}>
                      <div style={{ flex: 1, minWidth: 140 }}>
                        <div className={cl.vozNome}>{v.nome}</div>
                        <div className={cl.vozDesc}>
                          Autorizado por {v.autorizadoPor} ·{" "}
                          {new Date(v.criadaEm).toLocaleDateString("pt-BR")}
                        </div>
                      </div>
                      <IconButton
                        size="small"
                        className={cl.play}
                        onClick={() =>
                          tocar(amostraDaVoz(v.nome), { provedor: "elevenlabs", elevenlabs: { vozId: v.id } }, v.id)
                        }
                      >
                        {gerando === v.id ? (
                          <CircularProgress size={14} style={{ color: "#fff" }} />
                        ) : (
                          <PlayArrowRoundedIcon fontSize="small" />
                        )}
                      </IconButton>
                      <Button
                        size="small"
                        variant={emUso ? "contained" : "outlined"}
                        disabled={emUso}
                        onClick={() => usarVozPropria(v)}
                      >
                        {emUso ? "Em uso" : "Usar esta voz"}
                      </Button>
                      <IconButton size="small" onClick={() => excluirVozPropria(v)}>
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AbaAudio;
